import React from "react"
import WidgetCommonContainer, {
  WidgetCommonFTUContainer,
} from "@/components/widgets/WidgetCommonContainer"
import BottomIcon from "@/assets/clipart/widgets/rewards-bottom-icon.svg"
import { useUser } from "@/queries/user"
import { numberWithCommas } from "@/utils/NumberUtils"
import { WidgetWrapper } from "./WidgetWrapper"
import { router } from "expo-router"
import * as HomeEvents from "@/analytics/events/home"

export default function RewardsWidgetOld() {
  const { data: user } = useUser()
  const balance = user?.me?.lastPointTransaction?.balance ?? 0
  const hasRewards: boolean = balance > 0 || false
  // To test....
  // const hasRewards: boolean = false

  const ctaText = hasRewards
    ? `Earn more\npoints`
    : `Refer friends.\nEarn up to\n$1,500`

  const onPress = () => {
    HomeEvents.homepageWidgetClicked({
      nextScreen: "Rewards",
      widgetType: "widget-rewards",
      widgetTitle: "Rewards",
      widgetState: hasRewards ? "non-zero-value" : "zero-value",
      widgetValue: hasRewards ? balance.toString() : undefined,
      widgetCta: ctaText,
    })
    router.push("/rewards/")
  }

  return (
    <WidgetWrapper
      title="Rewards"
      category="rewards"
      orientation="vertical"
      onPress={onPress}
    >
      {!hasRewards ? (
        <WidgetCommonFTUContainer
          headerText={ctaText}
          BottomIconComponent={BottomIcon}
        />
      ) : (
        <WidgetCommonContainer
          headerCount={numberWithCommas(balance)}
          subTitle={"Points"}
          ctaText={ctaText}
        />
      )}
    </WidgetWrapper>
  )
}
